import React from "react";
import RichText from "./richText";

function groupBy(objectArray, property) {
  return objectArray.reduce(function (acc, obj) {
    let key = obj[property];
    if(!key) return acc;
    if (!acc[key]) {
      acc[key] = [];
    }
    acc[key].push(obj);
    return acc;
  }, {});
}

function convertArrayToObject(array, key) {
  const initialValue = {};
  return array.reduce((obj, item) => {
    return {
      ...obj,
      [item[key]]: item,
    };
  }, initialValue);
}

function getDescription(item) {
  if (!item) return;
  if (item.node)
    return item.node.longDescription.raw ? (
      <RichText description={item.node.longDescription} />
    ) : (
      item.node.longDescription
    );
  if (item.longDescription)
    return item.longDescription.raw ? (
      <RichText description={item.longDescription} />
    ) : item.longDescription.description ? (
      item.longDescription.description
    ) : (
      item.longDescription
    );
  return item.longDescription;
}

function getImageAltText(image) {
  //takes a contentful media object and returns the best alt text.
  //favours description over title, otherwise return "" which is ok for presentational images.
  return image?.description ? image.description : image?.title ? image.title : "";
}

function getImageFromAuthorName(authorName, authors) {
  const author = authors.find((author) => author.firstName + ' ' + author.lastName === authorName);
  const fallbackImage = {
    file: {
      url: '../images/icons/duo/user-account-duo.svg',
      fileName: 'default.jpg',
      contentType: 'image/svg+xml',
    },
    description: '',
    gatsbyImageData: null
  }
  if(!author) return fallbackImage;

  return author.profilePicture;
}

function getVideoSrcProvider(video) {
  if (!video) return;
  if (video.MuxVideo) {
    return {
      src: video.MuxVideo.playbackId,
      provider: "muxVideo",
    };
  } else if (video.vimeoId) {
    return {
      src: video.vimeoId,
      provider: "vimeo",
    };
  } else if (video.youTubeId) {
    return {
      src: video.youTubeId,
      provider: "youtube",
    };
  } else if (video.loomId) {
    return {
      src: video.loomId,
      provider: "loom",
    };
  }
}

// sort the array by alphabetical order
function sortArrayAlphabetically(array) {
  if (!array) return; 
  return array.sort((a, b) => a.localeCompare(b))
}

export { groupBy, convertArrayToObject, getDescription, getImageAltText, getImageFromAuthorName, getVideoSrcProvider, sortArrayAlphabetically };
